/* global axios */
import ApiClient from './ApiClient';

class PaymentAPI extends ApiClient {
  constructor() {
    super('payments', { accountScoped: true });
  }

  get(page = 1, sortAttr = '-created_at', clientId = null, filters = {}) {
    let requestURL = `${this.url}?page=${page}&sort=${sortAttr}`;
    if (clientId) {
      requestURL += `&client_id=${clientId}`;
    }
    if (filters.dateFrom) {
      requestURL += `&date_from=${filters.dateFrom}`;
    }
    if (filters.dateTo) {
      requestURL += `&date_to=${filters.dateTo}`;
    }
    if (filters.requestStatus !== null && filters.requestStatus !== undefined && filters.requestStatus !== '') {
      requestURL += `&request_status=${filters.requestStatus}`;
    }
    if (filters.paymentStatus !== null && filters.paymentStatus !== undefined && filters.paymentStatus !== '') {
      requestURL += `&payment_status=${filters.paymentStatus}`;
    }
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }
}

export default new PaymentAPI();
